import {
  tryCatch
} from "./chunk-6RM3PD3A.mjs";
import "./chunk-WBQAMGXK.mjs";
import {
  ean13CheckDigit,
  generateWeightBarcode
} from "./chunk-CQXE7XDK.mjs";
import {
  import_dayjs
} from "./chunk-N3FPAYTP.mjs";
import {
  bytesToMB,
  capitalize,
  columize,
  convertArToEn,
  convertNumberToLanguage,
  formatWeight,
  normalizePrice,
  objectEntries,
  objectKeys,
  objectValues,
  pointInPolygon
} from "./chunk-YMQ5HJDD.mjs";
import {
  LANGUAGES
} from "./chunk-XNOKFF3T.mjs";
import {
  ORDER_TRANSITIONS
} from "./chunk-SY6JA3X5.mjs";
import {
  CASHIER_ACTIONS
} from "./chunk-EXFS22VO.mjs";
import {
  priceFromDBFormat,
  priceToDBFormat
} from "./chunk-CGOEPJ3K.mjs";
import {
  timeZones
} from "./chunk-HFDHSLSU.mjs";
import "./chunk-UJCSKKID.mjs";

// src/index.ts
function upcToScaleCode(upc) {
  if (!upc) return null;
  if (!upc.startsWith("20") || !/^\d+$/.test(upc) || upc.length !== 7 && upc.length !== 12) return null;
  const scaleCode = upc.slice(2, 7).replace(/^0+/, "");
  return scaleCode === "" ? "0" : scaleCode;
}
function scaleCodeToUpc(scaleCode, weight) {
  if (!/^\d{1,5}$/.test(scaleCode)) return null;
  if (weight !== void 0 && (weight < 0 || weight > 99999 || !Number.isInteger(weight))) return null;
  const base = `20${scaleCode.padStart(5, "0")}`;
  return weight !== void 0 ? `${base}${String(weight).padStart(5, "0")}` : base;
}
function arabicToEnglishNumbers(input) {
  const map = {
    "\u0660": "0",
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9"
  };
  return input.replace(/[٠-٩]/g, (d) => map[d] ?? d);
}
function normalizeArabic(text) {
  if (!text) return "";
  return text.replace(/\b(null|undefined)\b/gi, "").replace(/[أإآ]/g, "\u0627").replace(/[ؤ]/g, "\u0648").replace(/[ئ]/g, "\u064A").replace(/[ء]/g, "").replace(/ة/g, "\u0647").replace(/[يى]/g, "\u064A").replace(/[كڪگ]/g, "\u0643").replace(/چ/g, "\u062C").replace(/ڤ/g, "\u0641").replace(/پ/g, "\u0628").replace(/ۀ/g, "\u0647").replace(/ﻻ/g, "\u0644\u0627").replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 1632)).replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 1776)).replace(/٪/g, "%").replace(/ـ/g, "").replace(/[،؛؟«»]/g, " ").replace(/[\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06ED]/g, "").replace(/\u200C|\u200D|\uFEFF/g, "").replace(/\s+/g, " ").trim();
}
var export_dayjs = import_dayjs.default;
export {
  CASHIER_ACTIONS,
  LANGUAGES,
  ORDER_TRANSITIONS,
  arabicToEnglishNumbers,
  bytesToMB,
  capitalize,
  columize,
  convertArToEn,
  convertNumberToLanguage,
  export_dayjs as dayjs,
  ean13CheckDigit,
  formatWeight,
  generateWeightBarcode,
  normalizeArabic,
  normalizePrice,
  objectEntries,
  objectKeys,
  objectValues,
  pointInPolygon,
  priceFromDBFormat,
  priceToDBFormat,
  scaleCodeToUpc,
  timeZones,
  tryCatch,
  upcToScaleCode
};
